import React from 'react';
import { FileIconBase } from './_base';
const SlideFileIcon = (props) => (React.createElement(FileIconBase, Object.assign({}, props, { defaultColor: "#E07A1F", label: "PPT" })));
export default SlideFileIcon;
